export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "sima-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "sima-themeWrap" */'./ThemeImporter'),
  },
};
